/** Danish display for MedCom SKS administrative practitioner roles.
 * Source: CodeSystem medcom-core-PractitionerRolesSKSadministrativ.
 */
const SKS_ADMINISTRATIVE_ROLE_DISPLAY: Record<string, string> = {
  speciallaege: 'Speciallæge',
  speciallaegeipraksis: 'Speciallæge i praksis',
  cheflaege: 'Cheflæge',
  overlaege: 'Overlæge',
  afdelingslaege: 'Afdelingslæge',
  sygehuslaege: 'Sygehuslæge',
  sygeplejerske: 'Sygeplejerske',
  sundhedsplejerske: 'Sundhedsplejerske',
  socialogsundhedsassistent: 'Social- og sundhedsassistent',
  socialogsundhedsmedhjaelper: 'Social- og sundhedsmedhjælper',
  socialogsundhedsmehjaelper: 'Social- og sundhedsmedhjælper',
  sygehjaelper: 'Sygehjælper',
  plejer: 'Plejer',
  plejehjemsassistent: 'Plejehjemsassistent',
  tandlaege: 'Tandlæge',
  klinisktandtekniker: 'Klinisk tandtekniker',
  tandplejer: 'Tandplejer',
  farmaceut: 'Farmaceut',
  apoteker: 'Apoteker',
  psykolog: 'Psykolog',
  pyskolog: 'Psykolog',
  jordemoder: 'Jordemoder',
  fysioterapeut: 'Fysioterapeut',
  ergoterapeut: 'Ergoterapeut',
  bioanalytiker: 'Bioanalytiker',
  radiograf: 'Radiograf',
  diaetist: 'Diætist',
  diaetistassistent: 'Diætistassistent',
  audilogiassistent: 'Audilogiassistent',
  neurofysiologassistent: 'Neurofysiologassistent',
  kiropraktor: 'Kiropraktor',
  zoneterapeut: 'Zoneterapeut',
  psykoterapeut: 'Psykoterapeut',
  audiologopaed: 'Audiologopæd',
  laegesekretaer: 'Lægesekretær',
  ledendelaegesekretaer: 'Ledende lægesekretær',
  sygeplejesekretaer: 'Sygeplejesekretær',
  sygeplejesekretear: 'Sygeplejesekretær',
  fodterapeut: 'Fodterapeut',
  socialraadgiver: 'Socialrådgiver',
  ledendesocialraadgiver: 'Ledende socialrådgiver',
  laerer: 'Lærer',
  paedagog: 'Pædagog',
  beskaeftigelsesvejleder: 'Beskæftigelsesvejleder',
  bandagist: 'Bandagist',
  skomager: 'Skomager',
  optiker: 'Optiker',
};

export function sksAdministrativeRoleDisplay(code: string | null | undefined): string | null {
  if (!code) return null;
  return SKS_ADMINISTRATIVE_ROLE_DISPLAY[code] ?? null;
}
